<ion-header>
	<ion-row class="ion-align-items-center main-bg white header">
		<ion-icon (click)="dismiss()" class="white back-icon pointer" name="arrow-back"></ion-icon>
		<div class="toolbar-logo"></div>
	</ion-row>
</ion-header>

<ion-content>
	<!--
    <google-map (mapClick)="mapClick($event.latLng)" [center]="center" [options]="mapOptions" height="100%" width="100%">
        <map-marker
            *ngFor="let marker of markers"
            [label]="marker.label"
            [options]="marker.options"
            [position]="marker.position"
            [title]="marker.title"
        >
        </map-marker>
    </google-map>
    <div (click)="geo()" class="ion-footer">GO!</div> -->
</ion-content>
